import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  ROUTE_PATH,
 LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION,
 LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION,
 LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION
} from "../../app/constants";
import { Header, Button, ErrorMark } from "../../components/RegularComponents";
import CheckboxForm from "../../components/CheckBoxForm";
import TopNavigationBar from "../TopNavigationBar";
import { ERROR_STRING } from "../../app/errors";
import { setCurrentAgentMortgageProperty } from "../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import {applicationTypeFromLicenceSubType} from '../../redux/slice/applicationsUtils';

const MORTGAGE_APPLICATION_PROPERTY = "confirmCompletionRegulatoryInfo";

export const ConfirmCompletionRegulatoryInfo = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();

  const agentApplication = useSelector(currentAgentApplicationSelector);
  const licencingSubType = agentApplication?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION;
  const isPrincipalBroker = licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;
  const isAssociateBroker = licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION;

  const applicationMode = APPLICATION_MODE_NEW;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);

  const [confirmCheck, setConfirmCheck] = useState(false);
  const [saveApplicationError, setSaveApplicationError] = useState(false);
  const [showValidationError, setShowValidationError] = useState(false);


  const handleNext = () => {

    // disabling the next for associate broker flow
    // if(isAssociateBroker) { return  }


    if (!confirmCheck) {
      setShowValidationError(true);
      return;
    }

    setShowValidationError(false);

    // Set MORTGAGE PROP value
    dispatch(
      setCurrentAgentMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: true,
      })
    );

    const nextPath = isAssociateBroker
      ? `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_BROKER_APPLICATION_REVIEW}` //MRA_ASSOCIATE_RECOMMENDED_LICENCE
      : `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_BROKER_APPLICATION_REVIEW}`;

    dispatch(
      saveBusinessLicenceApplicationData(applicationType, applicationMode)
    )
      .then((data) => {
        // On to the next item
        dispatch(push(nextPath));
      })
      .catch((err) => {
        setSaveApplicationError(true);
      });
  };

  const handleModalClose = () => {
    // Set MORTGAGE PROP value
    dispatch(
      setCurrentAgentMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: confirmCheck,
      })
    );

    onEditSave();
  };

  const text = !isPrincipalBroker
    ? "I confirm that the applicant completed the regulatory information program"
    : "I confirm that I completed the regulatory information program";

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "30px" }}
                  id="complete-mortgage-education-header"
                  header="Confirm completion of the regulatory information program"
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <CheckboxForm
              id="confirm-before-start-checkbox"
              checked={confirmCheck}
              value={confirmCheck}
              labelText={text}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck(val);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div
            className={
              "col-lg-4" +
              (saveApplicationError || showValidationError ? " has-error" : "")
            }
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={!isModal ? handleNext : handleModalClose}
            />
            {(saveApplicationError || showValidationError) && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CONFIRM_MORTGAGE_EDUCATION_REQUIREMENT}
              </div>
            )}
            {saveApplicationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
